import { createContext, useContext } from 'react';

/** Whether the pieces below render on an Encre surface (set by `EncreTone`). */
export const EncreToneContext = createContext(false);

/** Whether this piece renders on an Encre surface (then: `desk-*` tokens, dark with the page). */
export function useEncreTone(): boolean {
  return useContext(EncreToneContext);
}
